import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
    wrapper: {
        border: "1px solid #FFFFFF4D",
        borderRadius: 12,
        padding: 8,
        marginBottom: 24,
        '&:has(> :nth-child(2))': {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridColumnGap: "5px",
        }
    },
    frenemiesIcon: {
        width: 24,
        height: 24,
        objectFit: "contain",
        marginRight: 8,
    },

    tab: {
        width: "100%",
        height: 56,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: 0.5,
        cursor: "pointer",
        transition: "0.3s ease",
        borderRadius: 4,
    },

    tabActive: {
        background: "#00BA6C4D",
        opacity: 1,
    },

    tabText: {
        fontSize: 16,
        fontWeight: 700,
        lineHeight: "19.5px",
        color: "#FFFFFF4D",
        transition: "0.3s ease",
    },

    tabTextActive: {
        color: "#F5F5F5",
    },
});
